const ID = 'summary';

export default ID;
